import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class AuthService {

  consultaUsers = this.afstore.collection('users').ref;

  constructor(
    private afAuth: AngularFireAuth,
    public afstore: AngularFirestore,
    private router: Router) {}

  login(email: string, password: string) {
    var promise = new Promise((resolve, reject) => {
      this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .then(value => {
        this.consultaUsers.doc(value.uid).onSnapshot((doc) => {
            resolve(doc.data().nivel);
        })
      })
      .catch(err => {
        console.log('Something went wrong: ', err.message);
      })
    });
    return promise;
  }

  emailSignup(newuser) {
    var promise = new Promise((resolve, reject) => {
      this.afAuth.auth.createUserWithEmailAndPassword(newuser.email, newuser.password).then(() => {
        this.afAuth.auth.currentUser.updateProfile({
          displayName: newuser.displayName,
          photoURL: 'https://firebasestorage.googleapis.com/v0/b/myapp-4eadd.appspot.com/o/chatterplace.png?alt=media&token=e51fa887-bfc6-48ff-87c6-e2c61976534e'
        }).then(() => {
          this.consultaUsers.doc(this.afAuth.auth.currentUser.uid).set({
            uid: this.afAuth.auth.currentUser.uid,
            displayName: newuser.displayName,
            photoURL: 'https://firebasestorage.googleapis.com/v0/b/myapp-4eadd.appspot.com/o/chatterplace.png?alt=media&token=e51fa887-bfc6-48ff-87c6-e2c61976534e',
            nivel: newuser.nivel
          }).then(() => {
            resolve({ success: true });
            }).catch((err) => {
              reject(err);
          })
          }).catch((err) => {
            reject(err);
        })
      }).catch((err) => {
        reject(err);
      })
    })
    return promise;
  }

  editarUsuario(idUsuario, olduser){
    return new Promise((resolve, reject) => {
      this.consultaUsers.doc(idUsuario).update({
        displayName: olduser.displayName,
        nivel: olduser.nivel
      }).then(() => {
        resolve({ success: true });
        }).catch((err) => {
          reject(err);
      })
    });
  }

  googleLogin() {
    const provider = new firebase.auth.GoogleAuthProvider();
    return this.oAuthLogin(provider)
      .then(value => {
     console.log('Sucess', value),
     this.router.navigateByUrl('/profile');
   })
    .catch(error => {
      console.log('Something went wrong: ', error);
    });
  }

  logout() {
    this.afAuth.auth.signOut().then(() => {
      this.router.navigate(['/email-login']);
    });
  }

  private oAuthLogin(provider) {
    return this.afAuth.auth.signInWithPopup(provider);
  }
}


// WEBPACK FOOTER //
// ./src/app/auth.service.ts